import _ from 'lodash';
function formatLeftFilterConfig(filterConfigData) {
    const { filterConfigs, } = filterConfigData;
    // 需要四合一的字段
    const combinationType = ['IPC_FACET', 'CPC_FACET', 'LOC_FACET', 'UPC_FACET'];
    const fieldStructure = {
        Classification: {
            field: 'CLASSIFICATION_TYPE',
            type: 'combination',
            children: [],
        },
    };
    _.forEach(filterConfigs, item => {
        item.type = 'default';
        if (item.groups && item.groups.length) {
            item.type = 'group';
            item.defaultChild = _.get(item.groups.find(({ selected, }) => !!selected), 'field', '');
            item.children = item.groups;
        }
        if (_.includes(combinationType, item.field)) {
            fieldStructure.Classification.children.push(item);
        }
        else {
            item.title = item.field;
            fieldStructure[item.field] = item;
        }
    });
    if (!_.get(fieldStructure, 'Classification.children.length')) {
        delete fieldStructure.Classification;
    }
    // 处理四合一之后将数据转为需要的格式
    const filterItems = _.map(_.values(fieldStructure), item => {
        const { field: key, selected: isExpand, tooltip, } = item;
        return {
            key, isOpened: isExpand, context: item, tooltip, title: key,
        };
    });
    return filterItems;
}
export default formatLeftFilterConfig;
